import { useState, useEffect } from 'react';

function getState() {
    return {
        isMobile:  window.matchMedia('(max-width: 767px)').matches,
        isTablet:  window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches,
        isDesktop: window.matchMedia('(min-width: 1024px)').matches,
        width:     window.innerWidth,
    };
}

export default function useBreakpoint() {
    const [bp, setBp] = useState(getState);

    useEffect(() => {
        const mqMobile  = window.matchMedia('(max-width: 767px)');
        const mqTablet  = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
        const handler   = () => setBp(getState());

        mqMobile.addEventListener('change', handler);
        mqTablet.addEventListener('change', handler);
        window.addEventListener('resize', handler);

        return () => {
            mqMobile.removeEventListener('change', handler);
            mqTablet.removeEventListener('change', handler);
            window.removeEventListener('resize', handler);
        };
    }, []);

    return bp;
}
